// Recharts theme for the editorial look: ink and grays by default, one
// emphasis color (azure) for the series a chart is about, red only for a
// cautionary series. Values are CSS variables from panda.config.ts (ed.*)
// so they follow light and dark mode. See ./editorial/tokens.ts.
import { ed } from "./editorial/tokens";

export const chartColors = {
  primary: ed.ink, // the default single series reads as ink
  emphasis: ed.emph, // azure: the one thing the chart calls out
  secondary: ed.markStrong,
  tertiary: ed.mark,
  success: ed.ink,
  warning: ed.markStrong,
  danger: ed.caution, // red-600, cautionary series only
  muted: ed.mark,
};

export const chartTheme = {
  grid: {
    stroke: ed.grid,
    strokeDasharray: "0",
  },
  axis: {
    stroke: ed.rule,
    tick: {
      fill: ed.ink3,
      fontSize: 11,
      fontFamily: ed.mono,
    },
  },
  tooltip: {
    contentStyle: {
      backgroundColor: ed.paper,
      border: `1px solid ${ed.ink}`,
      borderRadius: "0",
      boxShadow: "none",
      padding: "8px 10px",
      fontFamily: ed.sans,
      fontSize: "12px",
    },
    labelStyle: {
      color: ed.ink,
      fontWeight: 700,
      marginBottom: "2px",
    },
    itemStyle: {
      color: ed.ink2,
      fontFamily: ed.mono,
      fontSize: "12px",
    },
  },
  legend: {
    wrapperStyle: {
      paddingTop: "16px",
      fontSize: "12px",
      fontFamily: ed.sans,
    },
  },
};

// Multi-series order: the lead series in emphasis, the rest in ink and
// grays so they recede; red last and only for a cautionary series.
export const seriesColors = [
  ed.emph,
  ed.ink,
  ed.markStrong,
  ed.mark,
  ed.caution,
  ed.ink3,
  ed.rule,
  ed.ink2,
];

export function getSeriesColor(index: number): string {
  return seriesColors[index % seriesColors.length] ?? chartColors.primary;
}
